export enum RoutePermission {
    MAIN = 'main',
    POSTING = 'posting',
    ADVERTISING = 'advertising',
    ADVERTISING_PARTNERS = 'advertisingPartners',
    ADVERTISING_PARTNERS_ADD = 'advertisingPartnersAdd',
    ADVERTISING_PARTNERS_EDIT = 'advertisingPartnersEdit',
    ADVERTISING_BUY = 'advertisingBuy',
    ADVERTISING_SELL = 'advertisingSell',
    // ADVERTISING_TOKENS = 'advertisingTokens',
    STATISTICS = 'statistics',
    SETTINGS = 'settings',
    CHANNELS = 'channels',
    PROFILE = 'profile'
}

export interface LastAppStateStore {
    page: string | null
    sessionId: string | null
    action: string | null
    postId: number | null

    setState: (data: Partial<Omit<LastAppStateStore, 'setState' | 'reset'>>) => void
    reset: () => void
}
